module.exports = __webpack_public_path__ + "img/consultation_d.2487df79.png";